import * as React from 'react';
import { uniqueId } from 'lodash';
import { AddButton, BodyGroup, HelperPopover } from '@component/index';
import { getAgentPathPrefix, instance, isReadMode } from '@lib/index';
import { QueryTableComp } from './query-table';
import '@style/component/data-query.less';
import { localizedString } from '@locale/index';
import {
  Attribute,
  ProviderType,
  DataQueryUpdateFuncArgumentConfig,
  DataQuery,
  FrameItem,
  IntentInfo,
  CompositeInfo,
  EntityInfo,
  GenericType,
  ExternalType,
  dataQueryToServer,
  FrameType,
  ReferenceNode
} from '@interface/index';
import { API } from '@config/api';
import { message } from 'antd';
import { TypeDefinition, TypeDefinitionSelect, TypeSelect } from './modal-comps';

export interface DataQueryCompProps {
  title: string;
  frame: FrameItem;
  providerType?: ProviderType;
  availableIntents: IntentInfo[];
  availableComposites: CompositeInfo[];
  availableEntities: EntityInfo[];
  genericTypes: GenericType[];
  externalTypes: ExternalType[];
  disabled?: boolean;
  data: DataQuery[];
  selectedParameters: Attribute[];
  onChange: (args: DataQueryUpdateFuncArgumentConfig) => void;
  setLoading?: (loading: boolean) => void;
}
export interface DataQueryCompState {
  tag: string;
}

export class DataQueryComp extends React.PureComponent<
  DataQueryCompProps,
  DataQueryCompState
> {
  public state: DataQueryCompState = {
    tag: uniqueId()
  };

  setLoading(loading: boolean) {
    if (this.props.setLoading) {
      this.props.setLoading(loading);
    }
  }

  private bodyGroup?: BodyGroup;

  render() {
    const { disabled = false,
      title,
      frame,
      data,
      availableIntents,
      availableComposites,
      availableEntities,
      externalTypes,
      genericTypes
    } = this.props;

    return (
      <BodyGroup
        foldable
        title={title.length ? title : localizedString('data_query')}
        titleExtra={<HelperPopover localizedKey="function_hint" />}
        extra={(
          <TypeDefinitionSelect
            placeholder="Add function by return type"
            style={{ width: 200 }}
            params={{
              availableIntents,
              availableComposites,
              availableEntities,
              externalTypes,
              genericTypes
            }}
            frame={frame}
            onChange={this.handleNewTableRow}
          />)
        }
        onRef={(ref: any) => {
          this.bodyGroup = ref;
        }}
      >
        <div className="suggestion__wrap">
          <div className="sug-wrap">{this.tableComp()}</div>
        </div>
      </BodyGroup >
    );
  }

  tableComp = () => {
    const props = this.props;
    const state = this.state;
    const {
      availableIntents,
      availableComposites,
      availableEntities,
      genericTypes,
      externalTypes,
      providerType
    } = props;

    return (
      <QueryTableComp
        title={props.title}
        frame={props.frame}
        providerType={providerType}
        availableIntents={availableIntents}
        availableComposites={availableComposites}
        availableEntities={availableEntities}
        genericTypes={genericTypes}
        externalTypes={externalTypes}
        tag={state.tag}
        disabled={props.disabled}
        selectedParameters={props.selectedParameters}
        data={props.data || []}
        onChange={props.onChange}
      // onAdd={this.handleNewTableRow}
      />
    );
  };

  getOwnerPath() {
    const type = this.props.frame.type;
    switch (type) {
      case FrameType.intent:
        return 'intent';
      case FrameType.composite:
        return 'frame';
      case FrameType.entity:
        return 'entity';
      case FrameType.service:
        return 'service';
      default:
        return 'unknown';
    }
  }

  handleNewTableRow = (selected: TypeDefinition) => {

    const { frame, data } = this.props;

    const payload: DataQuery = {
      id: 'new',
      name: '',
      ownerId: frame.id,
      ownerType: frame.type,
      parameters: [],
      multiValue: selected.multiValued || false,
      allowTrigger: false,
      disableReturnNull: !selected.nullable,
      kotlin: false,
      frame: selected.baseType
    };

    window.open(`${getAgentPathPrefix()}/${this.getOwnerPath()}/${frame.id}/function/new?payload=${encodeURIComponent(JSON.stringify(payload))}`, '_self');

    // let name = '';
    // for (let i = 1; i <= data.length + 1; i++) {
    //   const tryName = `function${i}`;
    //   if (data.findIndex(item => item.name === tryName) === -1) {
    //     name = tryName;
    //     break;
    //   }
    // }

    // const info: DataQuery = {
    //   name,
    //   ownerId: frame.id,
    //   ownerType: frame.type,
    //   parameters: [],
    //   multiValue: selected.multiValued || false,
    //   allowTrigger: false,
    //   disableReturnNull: !selected.nullable,
    //   kotlin: false,
    //   frame: selected.baseType
    // };

    // this.setLoading(true);
    // API.dataQuery
    //   .create(param)
    //   .then((res: any) => {
    //     this.setLoading(false);
    //     window.open(`${getAgentPathPrefix()}/${this.getOwnerPath()}/${frame.id}/function/${res.id}`, '_self');
    //   })
    //   .catch((e: Error) => {
    //     this.setLoading(false);
    //     message.warning(e.message || localizedString('common_save_failed'));
    //     throw e;
    //   });
  };
}
